import PlaceIcon from '@mui/icons-material/Place'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import {blue, grey} from '@mui/material/colors'
import {useAppNavigate} from 'app/hooks/navigation/useAppNavigate'
import {IBusiness} from 'app/modules/discovery/core'
import {CInnovation} from 'app/modules/discovery/core/newmodels/innovation'
import {Link as RouterLink} from 'react-router-dom'
import {useTracking} from 'react-tracking'
import {useStylesBusinessSearchResult} from 'styles/useStyles'
import ShowMoreText from '../ShowMoreText'

export default function SimpleInnovationResult({
  innovation,
  scrollPosition,
  search,
  fromDir,
  fromProject,
  page,
  pid,
  tab,
  showFullInnovation,
  showFullBusiness,
}: {
  innovation: CInnovation
  scrollPosition?: number
  search?: string
  fromDir?: boolean
  fromProject?: boolean
  page?: number
  pid?: string
  tab?: string
  showFullInnovation?: (innovationId: string) => void
  showFullBusiness?: (busId: string) => void
}) {
  const navigate = useAppNavigate()
  const business = innovation.business ? (innovation.business as unknown as IBusiness) : undefined
  const {trackEvent} = useTracking<{entity: string; id: string}>()
  const classes = useStylesBusinessSearchResult()
  const route = `/innovations/detail?innovationId=${innovation.id}${
    scrollPosition ? `&scrollPosition=${scrollPosition}` : ''
  }${search || fromDir ? `&fromInnovationDirectory=${search ? search : 'tru'}` : ''}${
    page ? `&page=${page}` : ''
  }${
    tab
      ? `&retval=${location.pathname + location.search?.replaceAll('&', '+')}+innDetTab=${tab}`
      : ''
  }`

  //possible formatted fields, formatted for display here
  const abstractSplit = innovation.abstract?.includes('|')
    ? innovation.abstract?.split('|')
    : undefined
  const backgroundSplit = innovation.background?.includes('|')
    ? innovation.background?.split('|')
    : undefined
  const overviewSplit = innovation.overview?.includes('|')
    ? innovation.overview?.split('|')
    : undefined
  const ip_statusSplit = innovation.ip_status?.includes('|')
    ? innovation.ip_status?.split('|')
    : undefined
  //    navigate(route)
  return (
    <Box width={'100%'}>
      {/* name/title */}
      <Box display={'flex'} flexDirection={'column'}>
        <Box display={'flex'} flexWrap={'wrap'}>
          {fromDir ? (
            <RouterLink
              className='text-hover-primary'
              to={route}
              onClick={() => {
                trackEvent({entity: 'innovation', id: `${innovation.id}`})
              }}
              style={{
                color: blue[300],
                fontSize: '1.4em',
                fontWeight: 600,
              }}
            >
              {innovation?.name}
            </RouterLink>
          ) : fromProject && showFullInnovation ? (
            // <Button onClick={() => innovation.id && showFullInnovation(innovation.id)}>
            //   {' '}
            <Typography
              color={blue[300]}
              variant={'h6'}
              onClick={() => innovation.id && showFullInnovation(innovation.id)}
              style={{
                color: blue[300],
                fontSize: '1.3em',
                fontWeight: 600,
                cursor: 'pointer',
              }}
            >
              {innovation?.name}
            </Typography>
          ) : (
            // </Button>
            <RouterLink
              className='text-hover-primary'
              to={`/innovations/detail?innovationId=${innovation.id}`}
              style={{
                color: blue[300],
                fontSize: '1.3em',
                fontWeight: 600,
              }}
            >
              {innovation?.name}
            </RouterLink>
          )}
        </Box>
        {!tab && (
          <Box>
            <Box>
              {business ? (
                <Box
                  sx={{
                    display: 'flex',
                    fontSize: '22px',
                    alignItems: 'center',
                    fontWeight: '500',
                  }}
                  gap={1}
                >
                  {/* <Box flex={'0 0 auto'}>
                    <Box className={classes.imgContainer}>
                      {business?.logo ? (
                        <img className={classes.img} src={`${business?.logo}`} loading={'lazy'} />
                      ) : (
                        <span style={{fontSize: 12}}>
                          {business.name ? emGetInitials(business.name, 4) : ''}
                        </span>
                      )}
                    </Box>
                  </Box> */}
                  {fromDir ? (
                    <RouterLink
                      className='text-hover-primary'
                      to={`/businesses/detail?externalId=${
                        business.id
                      }&scrollPosition=${scrollPosition}&fromInnovationDirectory=${
                        search !== '' ? search : 'tru'
                      }${page ? `&page=${page}` : ''}`}
                      onClick={() => {
                        trackEvent({entity: 'business', id: `${business.id}`})
                      }}
                      style={{
                        color: '#005bb5',
                        textDecoration: 'underline',
                        fontSize: '16px',
                      }}
                    >
                      {business?.name}
                    </RouterLink>
                  ) : fromProject && showFullBusiness ? (
                    <Typography
                      onClick={() => business.id && showFullBusiness(business.id)}
                      style={{
                        color: blue[800],
                        fontSize: '16px',
                        fontWeight: 600,
                        cursor: 'pointer',
                        textDecoration: 'underline',
                      }}
                    >
                      {business?.name}
                    </Typography>
                  ) : (
                    <RouterLink
                      className='text-hover-primary'
                      to={`/businesses/detail?externalId=${business.id}`}
                    >
                      {business?.name}
                    </RouterLink>
                  )}

                  {/* for city,state */}
                  {business?.city && business?.state_province && (
                    <>
                      <PlaceIcon fontSize='small' sx={{marginLeft: 2, color: 'gray'}} />
                      <Typography variant={'h6'}>
                        {business?.city}, {business?.state_province}
                      </Typography>
                      <Typography variant={'h6'} ml={2} color={grey[600]}>
                        {business?.country ? business.country : ''}{' '}
                      </Typography>
                    </>
                  )}
                </Box>
              ) : (
                <></>
              )}
            </Box>
            {innovation.date_published_available && (
              <Box display={'flex'}>
                {' '}
                <Typography variant={'h6'} fontWeight={700}>
                  Publication Date
                </Typography>{' '}
                <Typography variant={'h6'} fontWeight={700}>
                  {innovation.date_published_available}
                </Typography>
              </Box>
            )}
          </Box>
        )}
      </Box>

      {innovation.abstract ? (
        <Box>
          <Typography variant={'h6'} fontWeight={600}>
            Abstract:
          </Typography>
          <Box p={1}>
            <ShowMoreText
              variant={'body1'}
              maxLen={500}
              text={innovation.abstract ?? ''}
              textParagraphArr={abstractSplit}
              emptyCondition={'no abstract'}
              moreString='...Show More'
              lessString='...Show Less'
            />
          </Box>
        </Box>
      ) : innovation.overview ? (
        <Box>
          <Typography variant={'h6'} fontWeight={600}>
            Overview:
          </Typography>
          <Box p={1}>
            <ShowMoreText
              variant={'body1'}
              maxLen={300}
              text={innovation.overview ?? ''}
              textParagraphArr={overviewSplit}
              emptyCondition={'no overview'}
              moreString='...Show More'
              lessString='...Show Less'
            />
          </Box>
        </Box>
      ) : innovation?.background ? (
        <Box>
          <Typography variant={'h6'} fontWeight={600}>
            Background:
          </Typography>
          <Box p={1}>
            <ShowMoreText
              variant={'body1'}
              maxLen={300}
              text={innovation?.background ?? ''}
              textParagraphArr={backgroundSplit}
              emptyCondition={'no background'}
              moreString='...Show More'
              lessString='...Show Less'
            />
          </Box>
        </Box>
      ) : (
        <Typography variant={'body1'}>No abstract, overview, or background provided</Typography>
      )}
      {(innovation?.ip_status || ip_statusSplit?.length) && (
        <Box display={'flex'} flexDirection={'column'}>
          <Typography variant={'h6'} fontWeight={600}>
            IP Status:
          </Typography>

          <Box p={1}>
            <ShowMoreText
              variant={'body1'}
              maxLen={100}
              fontSize='14px'
              text={innovation.ip_status ?? ''}
              textParagraphArr={ip_statusSplit}
              emptyCondition={'no status'}
            />
          </Box>
        </Box>
      )}
    </Box>
  )
}
